import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Avatar from "@material-ui/core/Avatar";
import styled from "styled-components";

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

const RankRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid #f0f0f0;
  background: #fff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
`;

const RankInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ProductName = styled.span`
  font-weight: 600;
  color: #1c1c1c;
`;

const RankTotal = styled.span`
  font-weight: 700;
  color: #32a852;
`;

function Rank({ rank }) {
  const [tabIndex, setTabIndex] = useState("view_product");

  return (
    <>
      <Tabs
        value={tabIndex}
        indicatorColor="primary"
        textColor="primary"
        onChange={(e, value) => setTabIndex(value)}
        aria-label="rank tabs"
      >
        <Tab value="view_product" label="Mais visualizados" />
        <Tab value="add_to_cart" label="Mais adicionados" />
        <Tab value="buy_product" label="Mais vendidos" />
      </Tabs>
      <ListContainer>
        {rank &&
          rank[tabIndex]?.map((item, index) => (
            <RankRow key={`${item.product}-${index}`}>
              <RankInfo>
                {item.image && (
                  <Avatar
                    alt={item.product}
                    src={item.image}
                    style={{ width: 40, height: 40 }}
                  />
                )}
                <ProductName>{item.product}</ProductName>
              </RankInfo>
              <RankTotal>{item.total}</RankTotal>
            </RankRow>
          ))}
      </ListContainer>
    </>
  );
}

export default Rank;
